<template>
  <div
    v-if="isEmulation || isFrozen"
    :style="{height: alertHeight + 'px' }"
    class="banner-warning"
  >
    <div
      ref="stickyAlert"
      class="sticky-alert"
      :class="{'alert-sidebar-open': sidebarOpen }"
      :style="{top: alertY}"
    >
      <div
        v-if="isEmulation"
        id="emulation-banner"
      >
        {{ $t(`${i18nPrefix}.emulation.banner`, { 'id': $getEmulatedPlatformId(), 'name': platformName }) }}
      </div>
      <div
        v-if="isFrozen"
        id="frozen-banner"
      >
        {{ $t(`${i18nPrefix}.frozenAccount`, { 'account': selectedAccount.accountID}) }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  GET_SELECTED_CUSTOMER_ACCOUNT,
  PRINCIPLE_GET_AUTHENTICATED,
  PRINCIPLE_GET_USER
} from '@/store/get-types'
import { EMULATION_AUTH_COMPLETE } from '../../shared/security/auth-events'
import * as actionTypes from '@/store/action-types'
import { mapActions } from 'vuex'
import { AccountStatus } from '@/components/platform/accounts-user-management/enum/accountStatus'

export default {
  name: 'EmulationBanner',
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      platformName: null,
      emulationAuthComplete: false,
      alertHeight: 0,
      alertY: 0,
      scrollY: 0
    }
  },
  computed: {
    account () {
      return this.$store.getters[PRINCIPLE_GET_USER]
    },
    selectedAccount () {
      return this.$store.getters[GET_SELECTED_CUSTOMER_ACCOUNT]
    },
    isEmulation () {
      return this.emulationAuthComplete && this.$isEmulationSession() && this.account
    },
    isFrozen () {
      return this.$store.getters[PRINCIPLE_GET_AUTHENTICATED] && this.selectedAccount && this.selectedAccount.status === AccountStatus.FROZEN
    },
    i18nPrefix () {
      return 'portalfrontendApp.topBar'
    }
  },
  watch: {
    sidebarOpen: function () {
      this.handleResize()
      this.handleScroll()
    },
    selectedAccount: function () {
      this.handleResize()
      this.handleScroll()
    }
  },
  mounted () {
    this.$bus.$on(EMULATION_AUTH_COMPLETE, this.init)
    if (this.$route.name !== 'EmulationTokenAuth') {
      if (this.$isEmulationSession()) {
        this.init()
      }
    }
    this.handleResize()
  },
  created () {
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener('resize', this.handleResize, true)
  },
  destroyed () {
    this.$bus.$off(EMULATION_AUTH_COMPLETE, this.init)
    window.removeEventListener('scroll', this.handleScroll, true)
    window.removeEventListener('resize', this.handleResize, true)
  },
  methods: {
    ...mapActions({
      getPlatformAsync: actionTypes.GET_PLATFORM_ASYNC,
      getSelectedCustomerAsync: actionTypes.GET_SELECTED_CUSTOMER_ACCOUNT_ASYNC,
      updateSelectedAccount: actionTypes.UPDATE_THE_SELECTED_ACCOUNT,
      setSelectedCustomerAccount: actionTypes.UPDATE_THE_SELECTED_ACCOUNT
    }),
    async init () {
      this.emulationAuthComplete = true

      try {
        const emulatedPlatform = await this.getPlatformAsync({ platformClientId: this.$getEmulatedPlatformId() })
        this.platformName = emulatedPlatform.name
        await this.getSelectedCustomerAsync(true) // the "true" parameter allows for a force reload of the selected customer
      } catch (error) {
      }
    },
    handleResize () {
      this.alertHeight = this.$refs.stickyAlert?.clientHeight
    },
    handleScroll () {
      this.alertHeight = this.$refs.stickyAlert?.clientHeight
      const windowScroll = window.scrollY
      const downScroll = this.scrollY < windowScroll
      const tallerThanAlert = windowScroll > this.alertHeight
      if (this.isMobile && downScroll && tallerThanAlert) {
        this.alertY = (this.alertHeight * -1) + 'px'
      }
      if (!downScroll) {
        this.alertY = 0
      }
      this.scrollY = window.scrollY ? window.scrollY : this.scrollY
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/global.scss";
@import "~@/assets/scss/variables";
#emulation-banner,
#frozen-banner{
  display: flex;
  min-height: 40px;
  padding:1rem;
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.banner-warning {
  background-color: var(--t-color-status-warning);
}
.sticky-alert{
  position: fixed;
  top:0;
  width: calc(100% - 62px);
  right:0;
  z-index: 9001;
  transition: top 300ms, width 300ms ease;
  &.alert-sidebar-open {
    width: calc(100% - 220px);
    @include media-breakpoint-up(md) {
      width: calc(100% - 220px);
    }
  }
}
</style>
